import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './data/auth.service';

@Injectable({ providedIn: 'root' })
export class DonorGuard  {

    constructor(private authService: AuthService, private router: Router) { }

    //if user is donor, only allow access to donor area
    canActivate(): Promise<boolean> {
        return new Promise((resolve) => {
            this.authService.getAuthInfo().subscribe(
                auth => {
                    if (auth && auth.isAuthenticated) {
                        if (auth.securityType.toLowerCase() === 'campuslogic' ||
                            auth.securityType.toLowerCase() === 'donor' ||
                            auth.rights.includes('scholarshipuniverse.donor.module.view')) {
                            resolve(true);
                        } else if (auth.securityType.toLowerCase() === 'employee' || auth.securityType.toLowerCase() === 'externalreviewer') {
                            this.router.navigate(['/school']);
                            resolve(false);
                        } else {
                            this.router.navigate(['/student']);
                            resolve(false);
                        }
                    } else {
                        this.router.navigate(['/student']);
                        resolve(false);
                    }
                });
        });
    }

    canActivateChild = () => this.canActivate();

}
